import cardPhone from './phones/auth-phone-card.png';
import homePhone from './phones/auth-phone-home.png';

/**
 * Side phones are the published Home and My Card screenshots.
 * They are pictures only: no queries, no signed-in data, and no controls.
 * The parent stage marks them aria-hidden.
 */
export default function AuthPhones({ side }) {
  const src = side === 'right' ? cardPhone : homePhone;
  return (
    <img
      src={src}
      alt=""
      draggable="false"
      className="pik-auth-phone"
    />
  );
}
